export default __webpack_public_path__ + "static/media/flag-lebanon.45940f6c.svg";